module.exports = __webpack_public_path__ + "static/media/Ind_Clan_Header.0dc5fb7e.jpg";